import React from 'react';
import './style.css';
import RowComponent from './components/row';
import EditDoctorComponent from './components/edit-doctor/index';
import doctors from '../../../../services/doctors/index';
import DropdownComponent from '../../../../components/dropdown/index';
import withDoctorModal from '../../hocs/doctor-details/index';

export default withDoctorModal(class DoctorsComponent extends React.Component {
    state = {
        modal: "",
        doctor: null,
        doctors: [],
        display: [],
        status: "activo"
    }

    filterMenu = [
        {
            text: "Activos",
            onClick: () => this.filterDisplay("activo")
        },
        {
            divider: true
        },
        {
            text: "Inactivos",
            onClick: () => this.filterDisplay("inactivo")
        }
    ]

    filterDisplay = (status) => {
        let display = this.state.doctors.filter(doctor => doctor.status === status)
        this.setState({display: display, status: status})
    }

    componentWillMount() {
        doctors.find({}, (err, doctors) => {
            let display = doctors.filter(doctor => doctor.status === this.state.status);
            this.setState({doctors: doctors, display: display})
        })
    }

    replaceArray = (array, doctor) => {
        const index = array.findIndex(doc => doctor._id === doc._id);
        if(index !== -1)
            array.splice(index, 1, doctor)
    }

    replaceDoctor = (doctor) => {
        let display = Object.assign([], this.state.display);
        let doctors = Object.assign([], this.state.doctors);
        const indexDisplay = display.findIndex(doc => doctor._id === doc._id);
        const indexDoctors = doctors.findIndex(doc => doctor._id === doc._id);

        if(indexDisplay === -1 && doctor.status === this.state.status)
            display.push(doctor)
        else if(indexDisplay !== -1 && doctor.status === this.state.status)
            display.splice(indexDisplay, 1, doctor)
        else if(indexDisplay !== -1 && doctor.status !== this.state.status)
            display.splice(indexDisplay, 1)

        if(indexDoctors !== -1)
            doctors.splice(indexDoctors, 1, doctor);

        this.setState({display: display, doctors: doctors, modal: "", doctor: null});
    }

    addDoctor = (doctor) => {
        let display = Object.assign([], this.state.display)
        if(doctor.status === this.state.status)
            display.push(doctor)
        this.setState({display: display, doctors: this.state.doctors.concat(doctor), modal: "", doctor: null})
    }

    openModal = (modal, doctor = null) => this.setState({modal: modal, doctor: doctor})
    closeModal = () => this.setState({modal: '', doctor: null})

    render() {
        return (
            <React.Fragment>
                <div className="Doctors">
                    <div className="card">
                        <header className="card-header">
                            <h2 className="card-header-title">
                                Empleados
                            </h2>
                            <div style={{padding: 0}} className="card-header-icon header-button">
                                <DropdownComponent menu={this.filterMenu}
                                    title={<i className="fas fa-filter hover-color" aria-hidden="true"></i>}
                                    color="#449c8c" />
                            </div>
                            <a className="card-header-icon header-button"
                                onClick={() => this.openModal("edit")}>
                                <span className="icon">
                                    <i className="fas fa-plus" aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div className="card-content">
                            {this.state.display.length > 0 ?
                            <table className="table is-fullwidth is-hoverable">
                                <thead>
                                    <tr>
                                        <th>Nombre(s)</th>
                                        <th>Apellidos</th>
                                        <th>Estado</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                {this.state.display.map((doctor, index) => <RowComponent openDetails={this.props.openDoctorDetails} edit={this.openModal} key={doctor._id} doctor={doctor} />)}
                            </table> :
                            <p>No hay doctores...</p>}
                        </div>
                    </div>
                </div>
                <EditDoctorComponent isActive={this.state.modal === "edit"}
                    close={this.closeModal}
                    doctor={this.state.doctor}
                    addDoctor={this.addDoctor}
                    replaceDoctor={this.replaceDoctor}
                />
            </React.Fragment>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/doctors/index.js